import { useAuth } from '@izimi/auth';
import { getFirestoreDb } from '@izimi/core';
import { RealtimeCacheSync as BaseRealtimeCacheSync, useModules } from '@izimi/modules';

export const RealtimeCacheSync = () => {
  const { isAuthenticated } = useAuth();
  const {
    user: { useCurrentUser },
  } = useModules();

  const { currentUser } = useCurrentUser(Boolean(isAuthenticated));

  if (!currentUser) {
    return null;
  }

  return <BaseRealtimeCacheSync firestore={getFirestoreDb()} user={currentUser} />;
};
